export const getContactMapStatus = (contact, accounting, accountingCustomers)=>{
    const integratedId = contact.integratedId({
        accounting
    });
    const accountingCustomer = accountingCustomers.find((customer)=>customer.id() === integratedId);
    if (integratedId && accountingCustomer) {
        return 'mapped';
    }
    if (integratedId && !accountingCustomer) {
        return 'failedToMap';
    }
    return 'notMapped';
};
